import { useEffect, useMemo } from "react";
import { useLocation, matchPath } from "react-router-dom";
import images from "../../images";
import "./WatiWidget.css";

const CUSTOM_PAGES_CONFIG = [
  { path: "/quest/location/:id", marginBottom: "30" },
];

const PAGES_HIDE_CTA_TEXT = ["/quest/location/:id"];

const DEFAULT_MARGIN_BOTTOM = "50";
const DEFAULT_CTA_TEXT = "Questions?";

const WatiWidget = () => {
  const phoneNumber = process.env.REACT_APP_WATI_PHONE_NUMBER;
  const idWatiGenerate = process.env.REACT_APP_WATI_GENERATE_ID;

  const location = useLocation();

  const currentConfig = useMemo(() => {
    return CUSTOM_PAGES_CONFIG.find((config) =>
      matchPath({ path: config.path, end: false }, location.pathname),
    );
  }, [location.pathname]);

  const marginBottomValue = currentConfig
    ? currentConfig.marginBottom
    : DEFAULT_MARGIN_BOTTOM;

  const shouldHideCTAText = useMemo(() => {
    return PAGES_HIDE_CTA_TEXT.some((path) =>
      matchPath({ path: path, end: false }, location.pathname),
    );
  }, [location.pathname]);

  // Nếu thuộc danh sách ẩn thì set text = "", ngược lại để mặc định
  const ctaTextValue = shouldHideCTAText ? "" : DEFAULT_CTA_TEXT;

  useEffect(() => {
    if (
      window.watiWidgetLoaded &&
      !document.getElementById("whatsapp-chat-widget")
    ) {
      const watiUI = document.getElementById("whatsapp-chat-widget");
      if (watiUI) watiUI.remove();
      delete window.watiWidgetLoaded;
    }

    if (window.watiWidgetLoaded) return;

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = `https://wati-integration-prod-service.clare.ai/v2/watiWidget.js?${idWatiGenerate}`;

    const options = {
      enabled: true,
      chatButtonSetting: {
        backgroundColor: "#253FF6",
        ctaText: ctaTextValue,
        borderRadius: "25",
        marginLeft: "0",
        marginRight: "20",
        marginBottom: marginBottomValue,
        ctaIconWATI: false,
        position: "right",
      },
      brandSetting: {
        brandName: "Wati",
        brandSubTitle: "undefined",
        brandImg: images.LogoIcon,
        welcomeText: "Hi there!\nHow can I help you?",
        messageText: "Hello, %0A I have a question about",
        backgroundColor: "#253FF6",
        ctaText: DEFAULT_CTA_TEXT,
        borderRadius: "25",
        autoShow: false,
        phoneNumber: phoneNumber,
      },
    };

    const initWidget = () => {
      if (typeof window.CreateWhatsappChatWidget === "function") {
        window.CreateWhatsappChatWidget(options);
        window.watiWidgetLoaded = true;
      } else {
        setTimeout(initWidget, 100);
      }
    };

    script.onload = initWidget;

    const firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode.insertBefore(script, firstScript);

    return () => {
      if (window.watiWidgetLoaded) {
        const widgetScript = document.querySelector(
          'script[src*="wati-integration-prod-service"]',
        );
        if (widgetScript) widgetScript.remove();

        const watiUI = document.getElementById("whatsapp-chat-widget");
        if (watiUI) {
          watiUI.remove();
        }
        delete window.watiWidgetLoaded;
      }
    };
  }, [phoneNumber, idWatiGenerate, marginBottomValue, ctaTextValue]);

  return null;
};

export default WatiWidget;
